// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/save_experiment_as_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentData } from "./experiment_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_data } from "./experiment_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/save_experiment_as_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_request: GenFile = /*@__PURE__*/
  fileDesc("CkhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvc2F2ZV9leHBlcmltZW50X2FzX3JlcXVlc3QucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSLXAQoXU2F2ZUV4cGVyaW1lbnRBc1JlcXVlc3QSIAoTbmV3X2V4cGVyaW1lbnRfbmFtZRgBIAEoCUgBiAEBEhwKEmZyb21fZXhwZXJpbWVudF9pZBgDIAEoCUgAEk0KCmFzc2F5X2RhdGEYBCABKAsyNy5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuRXhwZXJpbWVudERhdGFIAEIVChNuZXdfZXhwZXJpbWVudF9kYXRhQhYKFF9uZXdfZXhwZXJpbWVudF9uYW1lYgZwcm90bzM", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_data]);

/**
 * Rpc request to save a created or modified experiment as a new experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsRequest
 */
export type SaveExperimentAsRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsRequest"> & {
  /**
   * New user-defined experiment name
   *
   * @generated from field: optional string new_experiment_name = 1;
   */
  newExperimentName?: string;

  /**
   * Experiment data to be saved
   *
   * @generated from oneof quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsRequest.new_experiment_data
   */
  newExperimentData: {
    /**
     * If an id is provided, the referenced experiment is duplicated and
     * saved with a new id
     *
     * @generated from field: string from_experiment_id = 3;
     */
    value: string;
    case: "fromExperimentId";
  } | {
    /**
     * If assay data is provided, a new assay is initialized
     *
     * @generated from field: quanterix.simoa_one.analysis_app_api.v1.ExperimentData assay_data = 4;
     */
    value: ExperimentData;
    case: "assayData";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.SaveExperimentAsRequest.
 * Use `create(SaveExperimentAsRequestSchema)` to create a new message.
 */
export const SaveExperimentAsRequestSchema: GenMessage<SaveExperimentAsRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_save_experiment_as_request, 0);

